import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reduce.js";
/* eslint-disable no-console */
import { isServiceInitialized, sendInternalError } from '../error-reporting';

// it is too dangerous to log in production. And this can happen. I'm putting this safety so we prevent this to happen.
var isLoggingEnabled = process && process.env && process.env.ENV && process.env.ENV.includes('prod');
var forwardErrorToServer;
var colors = {};
var getColor = function getColor(key) {
  if (colors[key]) {
    return colors[key];
  }
  var keyValue = 1 / Array.from(key).reduce(function (acc, _, index) {
    return acc + key.charCodeAt(index);
  }, 4224);
  var thisColor = "#" + Math.floor(keyValue * 16777215).toString(16);
  colors[key] = thisColor;
  return thisColor;
};
var sendToServerInternalError = function sendToServerInternalError(_ref) {
  var functionName = _ref.functionName,
    text = _ref.text,
    object = _ref.object;
  if (isServiceInitialized()) {
    var error = functionName + " - " + text + " , stack: " + (object && object.stack || '');
    sendInternalError(error, object);
  }
};
var isError = function isError(method) {
  return method === 'error';
};
var log = function log(method) {
  return function (functionName, text, object) {
    if (isLoggingEnabled) {
      var timeNow = +new Date();
      if (isError(method) && forwardErrorToServer) {
        sendToServerInternalError({
          functionName: functionName,
          text: text,
          object: object
        });
      }
      return console[method]("%c" + timeNow + ":%c" + functionName + " %c- " + text, "color: green; font-weight: bold;", "color: " + getColor(functionName) + "; font-weight: bold; text-decoration: underline", 'font-weight: bold;', object !== undefined ? object : '', object && object.stack || '');
    }
    return undefined;
  };
};
var execute = function execute(method) {
  return log(method);
};
var executeWithExtraInfo = function executeWithExtraInfo(method, position, group) {
  var scopedLogger = log(method);
  return function (text, object) {
    return scopedLogger(position, group ? group + " - " + text : text, object);
  };
};
export var activateLogging = function activateLogging(value) {
  isLoggingEnabled = value;
};
export var setForwardErrorsToServer = function setForwardErrorsToServer(value) {
  forwardErrorToServer = value;
};
export var logger = {
  log: execute('log'),
  error: execute('error'),
  info: execute('info'),
  warn: execute('warn'),
  loggerIn: function loggerIn(position) {
    return {
      log: executeWithExtraInfo('log', position),
      error: executeWithExtraInfo('error', position),
      info: executeWithExtraInfo('info', position),
      warn: executeWithExtraInfo('warn', position),
      // group logging
      groupIn: function groupIn(group) {
        return {
          log: executeWithExtraInfo('log', position, group),
          error: executeWithExtraInfo('error', position, group),
          info: executeWithExtraInfo('info', position, group),
          warn: executeWithExtraInfo('warn', position, group)
        };
      }
    };
  }
};
if (typeof window !== 'undefined') {
  window.logger = {
    activateLogging: activateLogging
  };
}
export default logger;